export class MottagningsplatsDetaljerTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        rubik: "Mottagningsplats",
        mottagningsplatsnummer: "MOTTAGNINGSPLATSNUMMER *",
        namn: "Namn *",
        aktiv: "Aktiv",
        beraknaNarmasteIndustri: "Beräkna avstånd till närmaste industri",
        mottagningsplatstyp: "MOTTAGNINGSPLATSTYP *",
        ansvariglogistiker: "ANSVARIG LOGISTIKER",
        beskrivning: "BESKRIVNING",
        alla: "Alla",

        mottagningsplats_list_kundensmottagningsplats: "Kundens mottagningsplats",

        mottagningsplats_list_sveaskogterminal: "Sveaskogs terminal",
        avlastningsplats: "AVLASTNINGSPLATS",
        koordinater: "KOORDINATER",
        typaheadefaulttext: "Ange minst tre tecken",
        validationNamn: "Namn måste anges",
        validationLand: "Land måste anges",
        validationMotagningsplatsnummer: "Mottagningsplatsnummer får inte vara tomt",
        validationMottagningsplatsTyp: "Mottagningsplatstyp måste anges",
        land: "Land *",
        deleteHeader: "Radera mottagningsplats",
        deleteText: "Bekräfta radering av mottagningsplats",
        deleteConfirmed: "Mottagningsplaten borttagen",
        lamnaHeader: "Osparade förändringar",
        lamnaBody: "Det finns osparade förändringar."
    };
}
